<template>
  <div class="conf-wrp">
    <div class="content-wrp">
      <div class="content">
        <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
          <section>
            <div class="title">
              <span>上架设置</span>
            </div>
            <div class="conf">
              <el-form-item label="上架设置:" prop="shelfState">
                <el-radio-group v-model="value.shelfState">
                  <el-radio :label="1">立即上架</el-radio>
                  <el-radio :label="2">放入仓库中</el-radio>
                  <!-- <el-radio :label="2">放入草稿箱</el-radio> -->
                </el-radio-group>
              </el-form-item>
            </div>
          </section>
          <!-- <section>
            <div class="title">
                <span>物流设置</span>
            </div>
            <div class="conf">
              <el-form-item label="运费设置:" prop="shipSet" label-width="120px">
                <div class="ship-wrp" v-if="shopList.length > 0">
                  <div class="item" v-for="(item, idx) in shopList" :key="idx">
                    <div class="shopname">
                      <img class="shop-img" :src="item.icon"/>
                      <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px;">
                          <el-image :src="item.channelIcon" style="width: 18px; height: 18px;overflow: unset;top: 4px;"></el-image>
                      </el-tooltip>
                      <span>{{ item.shortTitle || item.title }}</span>
                    </div>
                    <el-select
                      :loading="selectLoading"
                      v-model="shipsValue[item.id]"
                      placeholder="请选择运费模板"
                      clearable
                      @visible-change="changeSelect(item.id, item.userId)"
                      width="150px"
                    >
                      <el-option
                        v-for="ship in shipsTemplate[item.id]"
                        :key="ship.id"
                        :label="ship.name"
                        style="width: 150px"
                        :title="ship.name"
                        :value="ship.id"
                      >
                      </el-option>
                    </el-select>
                    <div><el-link class="no-border" @click="refreshTemplate(item.id, item.userId)">刷新模板</el-link></div>
                  </div>
                </div>
                <span v-else class="no-shops">暂无平台店铺</span>
              </el-form-item>
            </div>
          </section> -->
          <div class="btns">
            <el-button type="primary" @click="save">保存模板</el-button>
            <el-button @click="back">返回</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/prod.scss';
import { getShopList } from '@servers/base/shop/index.js';
import { getDistributionConfig, updateDistributionConfig,getWdTemplateList } from '@servers/prod/conf/index.js';

const PLATFORMID = 'weidian';

export default {
  name: 'WdConf',
  props: {
    back: Function,
  },
  components: {
  },
  data() {
    return {
      value: {
        shelfState:2,
        templateList:[], // 运费模版
      },
      rules: {
        shelfState: [{ required: true, message: '' }],
      },
      selectLoading: false,
      shopList:[],
      shipsValue: {
        // 运费模板
      },
      shipsTemplate: {
        // 运费模板列表
      },
    };
  },
  mounted() {
    this.getConf();
  },
  methods: {
    async getConf() {
      const res = await getDistributionConfig({ shopType: PLATFORMID });
      const shopList = this.$store.getters.get_AllShops_BySource('wd');
        // const shopList = await this.getShopList();
      this.shopList = shopList;
      if (res) {
        this.value.shelfState = res.shelfState || 2;
        this.intiTemplate(shopList,res.templateList || [])
      }
    },
    async getShopList() {
      const res = await getShopList({
        source: 'wd',
        pageNo: 1,
        pageSize: 300,
      });
      return res.list || [];
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { shelfState } = this.value;
          // const templateList = []; // 运费模版
          // Object.keys(this.shipsValue).forEach(id => {
          //   const name = this.findTemplateName(id, this.shipsValue[id]);
          //   const channel = this.shopList.find(shop => shop.id == id)?.channel
          //   templateList.push({
          //     shopId: id,
          //     templateId: this.shipsValue[id] || null,
          //     templateName: name || null,
          //     channel
          //   });
          // });
          const res = await updateDistributionConfig({
            shopType: PLATFORMID,
            shelfState,
            // templateList, // 运费模版
          });
          if (res) {
            this.$message.success('保存成功');
          }
        }
      });
    },
    intiTemplate(shopList, templateList=[]) {
        const ships = {};
        const shopUserIdMap = {};
        for (let shop of shopList) {
            ships[shop.id] = '';
            shopUserIdMap[shop.userId] = shop.id;
            this.shipsTemplate[shop.id] = [];
        }
        const shipsTemp = {};
        if (shopList.length && templateList) {
            templateList.forEach(item => {
            item.shopId = shopUserIdMap[item.shopId] || item.shopId;
            ships[item.shopId] = item.templateId;
            if (this.shipsTemplate[item.shopId] && !this.shipsTemplate[item.shopId].length) {
                shipsTemp[item.shopId] = [{ name: item.templateName, id: item.templateId }];
            }
            });
        }
        this.shipsTemplate = shipsTemp;
        this.shipsValue = ships;
    },
    async refreshTemplate(shopId, userId) {
      this.selectLoading = true;
      const list = await this.getTemplateList(userId);
      this.shipsTemplate[shopId] = list;
      const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
      if (idx === -1) {
        this.shipsValue[shopId] = '';
      }
      this.selectLoading = false;
      this.$message.success('刷新模板成功');
    },
    async getTemplateList(userId) {
      const list = await getWdTemplateList({ userId: userId });
      if (list) {
        return list.map(ship => {
          return {
            name: ship.templateName,
            id: ship.templateId,
          };
        });
      }
      return [];
    },
    async changeSelect(type,shopId) {
      if (
        !this.shipsTemplate[shopId] ||
        !this.shipsTemplate[shopId].length ||
        (this.shipsTemplate[shopId].length === 1 && this.shipsTemplate[shopId][0].id === this.shipsValue[shopId])
      ) {
        this.selectLoading = true;
        const list = await this.getTemplateList(userId);
        const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
        if (idx === -1) {
          this.shipsValue[shopId] = '';
        }
        this.shipsTemplate[shopId] = list;
        this.selectLoading = false;
      }
    },
    findTemplateName(type,shopid, tempId) {
      if (!this.shipsTemplate[shopid]) return '';
      for (let item of this.shipsTemplate[shopid]) {
        if (item.id === tempId) {
          return item.name;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>